import * as angular from "angular";
import {InvalidStatusComponent} from "./invalid-status/invalid-status.component";
import {TextCounter} from "./text-counter.directive";
import {AccessibleForm} from "./accessible-form.directive";
import {InlineCheckboxComponent} from "./inline-checkbox/inline-checkbox.component";
import {FormFieldComponent} from "./form-field/form-field.component";
import {FileUploadComponent} from "./file-upload/file-upload.component";
import {LayoutComponent} from "./layout/layout.component";
import {DocumentViewerDirective} from "./document-viewer.directive";
import {ArrayLengthValidator} from "../prior-study/array-length-validator";

export const WidgetModule = angular
    .module("app.shared.widget", [
        "ngAnimate",
        "ui.bootstrap",
        "checklist-model"
    ])

    .component("layout", LayoutComponent)
    .component("invalidStatus", InvalidStatusComponent)
    .component("inlineCheckbox", InlineCheckboxComponent)
    .component("formField", FormFieldComponent)
    .component("fileUpload", FileUploadComponent)
    .directive("documentViewer", DocumentViewerDirective.factory())
    .directive("accessibleform", AccessibleForm.factory())
    .directive("arrayLengthValidator", ArrayLengthValidator.factory())
    .directive("textCounter", TextCounter.factory())

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/widget.module.ts